module.exports = "https://99designs-start-assets.imgix.net/js/2491fb4fbfe7fac0b5fa56a82e83161d.svg";